import {
    RESET_PLAYERS,
    GET_ALL_PLAYERS,
    GET_ALL_PLAYERS_SUCCESS,
    GET_ALL_PLAYERS_ERROR,
    ASSIGN_COACH_TO_PLAYER,
    ASSIGN_COACH_TO_PLAYER_SUCCESS,
    ASSIGN_COACH_TO_PLAYER_ERROR,
    CHANGE_COACH_TO_PLAYER,
    CHANGE_COACH_TO_PLAYER_SUCCESS,
    CHANGE_COACH_TO_PLAYER_ERROR,
    REMOVE_COACH_TO_PLAYER,
    REMOVE_COACH_TO_PLAYER_SUCCESS,
    REMOVE_COACH_TO_PLAYER_ERROR,
    SELECT_PLAYER
} from '../constants/ActionTypes';

const INIT_PLAYERS_STATE = {
    allPlayers: [],
    playerInView: null,
    allPlayerLoader: false,
    allPlayersError: null,
    assignCoachToPlayerLoader: false,
    assignCoachToPlayerError: null,
    changeCoachToPlayerLoader: false,
    changeCoachToPlayerError: null,
    removeCoachToPlayerLoader: false,
    removeCoachToPlayerError: null
}

export default (state = INIT_PLAYERS_STATE, action) => {
    var playerData = []
    var selectedPlayer
    switch (action.type) {
        case RESET_PLAYERS: {
            return {
                ...INIT_PLAYERS_STATE
            }
        }
        case GET_ALL_PLAYERS: {
            return {
                ...state,
                allPlayerLoader: true
            }
        }
        case GET_ALL_PLAYERS_SUCCESS: {
            playerData = state.allPlayers
            return {
                ...state,
                allPlayers: playerData.concat(action.payload),
                allPlayerLoader: false,
                allPlayersError: null
            }
        }
        case GET_ALL_PLAYERS_ERROR: {
            return {
                ...state,
                allPlayersError: action.payload,
                allPlayerLoader: false
            }
        }

        case ASSIGN_COACH_TO_PLAYER: {
            return {
                ...state,
                assignCoachToPlayerLoader: true
            }
        }
        case ASSIGN_COACH_TO_PLAYER_SUCCESS: {
            playerData = state.allPlayers
            const index = playerData.findIndex(player => player.email === action.payload.email);
            selectedPlayer = playerData[index]
            if (selectedPlayer.email === action.payload.email) {
                if (action.payload.hasOwnProperty("eacl")) {
                    selectedPlayer.eacl = action.payload.eacl
                }
                playerData[index] = selectedPlayer
            }
            return {
                ...state,
                allPlayers: playerData,
                assignCoachToPlayerLoader: false,
                assignCoachToPlayerError: null
            }
        }
        case ASSIGN_COACH_TO_PLAYER_ERROR: {
            return {
                ...state,
                assignCoachToPlayerError: action.payload,
                assignCoachToPlayerLoader: false,
            }
        }

        case CHANGE_COACH_TO_PLAYER: {
            return {
                ...state,
                changeCoachToPlayerLoader: true
            }
        }
        case CHANGE_COACH_TO_PLAYER_SUCCESS: {
            playerData = state.allPlayers
            const index = playerData.findIndex(player => player.email === action.payload.email);
            selectedPlayer = playerData[index]
            if (selectedPlayer.email === action.payload.email) {
                if (action.payload.hasOwnProperty("eacl")) {
                    selectedPlayer.eacl = action.payload.eacl
                }
                playerData[index] = selectedPlayer
            }
            return {
                ...state,
                allPlayers: playerData,
                changeCoachToPlayerLoader: false,
                changeCoachToPlayerError: null
            }
        }
        case CHANGE_COACH_TO_PLAYER_ERROR: {
            return {
                ...state,
                changeCoachToPlayerError: action.payload,
                changeCoachToPlayerLoader: false
            }
        }

        case REMOVE_COACH_TO_PLAYER: {
            return {
                ...state,
                removeCoachToPlayerLoader: true
            }
        }
        case REMOVE_COACH_TO_PLAYER_SUCCESS: {
            playerData = state.allPlayers
            const index = playerData.findIndex(player => player.email === action.payload.email);
            selectedPlayer = playerData[index]
            if (selectedPlayer.email === action.payload.email) {
                if (action.payload.hasOwnProperty("eacl")) {
                    selectedPlayer.eacl = action.payload.eacl
                }
                playerData[index] = selectedPlayer
            }
            return {
                ...state,
                allPlayers: playerData,
                removeCoachToPlayerLoader: false,
                removeCoachToPlayerError: null
            }
        }
        case REMOVE_COACH_TO_PLAYER_ERROR: {
            return {
                ...state,
                removeCoachToPlayerError: action.payload,
                removeCoachToPlayerLoader: false
            }
        }
        case SELECT_PLAYER: {
            return {
                ...state,
                playerInView: action.payload
            }
        }
        default:
            return state;
    }
}